import { User, UserRole } from "../auth/store";
import { Client } from "../clients/store";
import { Campaign } from "../share/campaigns/store";
import { UserInList } from "../user-management/store";

export const getCampaignsAccessUsersData = (
  campaignCreatorUUID: string,
  userList: UserInList[],
  usersEnabledInCampaign: string[]
) => {
  const data = userList.map((user: UserInList) =>
    getCampaignAccessUserData(campaignCreatorUUID, user, usersEnabledInCampaign)
  );
  return data;
};

export const getCampaignAccessUserData = (
  campaignCreatorUUID: string,
  user: UserInList,
  usersEnabledInCampaign: string[]
) => {
  // Logic:
  // User is enabled if:
  // - it's in the enabled list
  // - it's an admin
  // - user is the creator of the campaign
  // User is NOT enabled by default if it's an invited user
  // (not real user yet)
  const userIsInvitedUser = user.invitationPendingStatus;
  const userIsAdmin = user.role === UserRole.ADMIN;
  const userIsCreator = campaignCreatorUUID === user.uuid;
  const defaultAccess = false;
  const userIsEnabled =
    usersEnabledInCampaign && usersEnabledInCampaign.includes(user.uuid);

  const userHasAccessToData =
    !userIsInvitedUser && (userIsAdmin || userIsCreator || userIsEnabled);

  let userData = {
    ...user,
    hasAccessToCampaign: userHasAccessToData || defaultAccess,
  };
  return userData;
};

export const displayCampaignAccessManagement = (
  campaign: Campaign | null,
  client: Client | null,
  user: User | null | undefined
) => {
  if (!user || !client || !campaign) return false;

  const userIsAdmin = client?.userRole === UserRole.ADMIN;
  const userIsCampaignCreator = campaign?.creator?.uuid === user?.uuid;
  const campaignAccessManagementIsEnabled =
    client?.contract?.hasCampaignAccessManagementEnabled;
  const displayCampaignManagementSection =
    campaignAccessManagementIsEnabled && (userIsAdmin || userIsCampaignCreator);
  return displayCampaignManagementSection;
};
